const forgetPasswordFormRedux = (state = null, action) => {
    switch (action.type) {
        case 'FORGETPASSWORDFORM_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'FORGETPASSWORDFORM_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default forgetPasswordFormRedux;